export default __webpack_public_path__ + "static/media/icon-ARC.3fc0d3f4.png";